import { TextArea } from '../../../../components/shared';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { setPersonaPrompt } from '../../../../redux/reducers';
import ProspectPageField from '../ProspectPageField';
import TabSection from '../TabSection';

const MIN_SCENARIO_ROWS = 20;

const CustomScenario = () => {
  const dispatch = useAppDispatch();
  const personaPrompt = useAppSelector((state) => state.prospect.fields.personaPrompt);

  return (
    <TabSection title="Scenario">
      <ProspectPageField
        label="Custom prompt"
        required
        content={
          <TextArea
            fitContent
            rows={MIN_SCENARIO_ROWS}
            placeholder="Write a custom prompt text here."
            value={personaPrompt}
            onChange={(e) => {
              dispatch(setPersonaPrompt({ value: e.target.value, isUserModified: true }));
            }}
          />
        }
      />
    </TabSection>
  );
};

export default CustomScenario;
